import './styles.scss'
import React from 'react'
import { COFFEEWEB_EXCHANGE } from 'Utils/Constants'
import MetaTagsComponent from 'Components/MetaTagsComponent'
import { t } from 'i18next'

function CoffeeExchange() {
  return (
    <>
      <MetaTagsComponent title={t('COFFEE_EXCHANGE_TITLES')} description={t('COFFEE_EXCHANGE_DESCRIPTION')} keywords={t('COFFEE_EXCHANGE_KEYWORDS')} url="https://coffeeweb.com/coffee-exchange" h1Content={t('COFFEE_EXCHANGE_H1_CONTENT')} />
      <div className="coffee-exchange-container">
        <video controls className="exchange-image" autoPlay loop playsInline>
          <source src={COFFEEWEB_EXCHANGE.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  )
}

export default CoffeeExchange
